import { ReactNode } from 'react'

import SummaryHeading from '@/components/view/atoms/heading/SummaryHeading'
import Area from '@/components/view/layouts/area/Area'
import AreaContent from '@/components/view/layouts/area/AreaContent'

interface Props {
  title: string
  subText?: string
  subNode?: ReactNode
  // カード内の余白を持たせずに children をそのまま置く（テーブルを端まで引く場合）
  noPadding?: boolean
  children: ReactNode
}

// GEO/LLMO分析結果の1セクション。
// 見出し・補足文をカードの外（上）に置き、内容を白カードで囲むデザインに揃える。
const GeoSection = ({ title, subText, subNode, noPadding = false, children }: Props) => (
  <div className='mb-4 flex flex-col gap-1'>
    <SummaryHeading subText={subText} subNode={subNode}>
      {title}
    </SummaryHeading>

    <Area>{noPadding ? children : <AreaContent>{children}</AreaContent>}</Area>
  </div>
)

export default GeoSection
